import { types } from 'mobx-state-tree';

export default types.model('SplitOrderAction',
    {
        ActionId: types.identifier,
        Message: types.string,
        ChangeOrderDeliveryDateToForecastDate: types.boolean,
        RequireStock: types.boolean
    });
